export const getters = {
  getTeams($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  getTeamById: $state => id => {
    return (
      Object.values($state.records).find(record => record.id === Number(id)) ||
      {}
    );
  },
  getMyTeams($state, $getters) {
    return $getters.getTeams.filter(team => {
      const { is_member: isMember } = team;
      return isMember;
    });
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getTeam: $state => id => {
    const team = $state.records[id];
    return team || {};
  },
  getMyTeamsNew: (state, $getters, rootState, rootGetters) => {
    const currentUserId = rootGetters.getCurrentUser?.id;
    if (!currentUserId) return [];

    return ($getters.getTeams || []).filter(team => {
      const memberIds = team.member_ids?.length
        ? team.member_ids
        : (team.members || []).map(m => m.id);

      return memberIds.includes(currentUserId);
    });
  },
  getMyTeamIds: (state, $getters) => {
    return ($getters.getMyTeams || []).map(team => Number(team.id));
  },
};
